import { MAGELLAN_PIXEL_ID } from '../config/config';

const MAGELLAN_PURCHASE_DEDUPE_KEY = 'trashie_magellan_purchase';

const script = '(function(w, d, n){' +
    'if (w.MAI) return;' +
    'w.MAI = w.MAI || {emit: function() {(w.MAI.q = w.MAI.q || []).push(arguments);}};' +
    'var e = d.createElement(n); e.async=1;' +
    'e.src = "https://cdn.mgln.ai/pixel.min.js";' +
    'var s = d.getElementsByTagName(n)[0];' +
    's.parentNode.insertBefore(e, s);' +
    '})(window, document, "script");' +
    `MAI.emit("conf", "${MAGELLAN_PIXEL_ID}");` +
    'MAI.emit("view");';

function getMagellanEmit() {
  const emit = window.MAI?.emit;
  return typeof emit === 'function' ? emit.bind(window.MAI) : null;
}

export function trackMagellanPageView() {
  const emit = getMagellanEmit();
  if (emit) emit('view');
}

export function trackMagellanPurchase(purchase = {}) {
  const emit = getMagellanEmit();
  if (!emit) return;

  const orderId = String(purchase.orderId ?? '');
  if (orderId) {
    try {
      const key = `${MAGELLAN_PURCHASE_DEDUPE_KEY}_${orderId}`;
      if (sessionStorage.getItem(key)) return;
      sessionStorage.setItem(key, '1');
    } catch {
      // sessionStorage full or unavailable; still emit once
    }
  }

  const amount = Number(purchase.amount);
  const normalizedAmount = Number.isFinite(amount) ? amount : 0;
  const currency = purchase.currency || 'USD';
  const metadata = purchase.metadata && typeof purchase.metadata === 'object'
    ? purchase.metadata
    : {};

  emit('purchase', normalizedAmount, currency, orderId, metadata);
}

export default script;
